export default {
  init() {
    var wWidth = window.matchMedia("(min-width: 768px)")
    setTimeout(() => {
      let ht = $('.col-wrapper').height();
      if (wWidth.matches) {
        $('#gform_wrapper_4').height(ht + 290);
        $('.gf_page_steps').height(ht + 290);
        $('#gform_next_button_4_48').css('marginTop', ht + 20);
      }
      $('#gform_next_button_4_48').attr('disabled', 'disabled');
    }, 100);


    $('.prod-button').on('click', function(event) {
      $(this).parent().parent().parent().parent().parent().addClass('active');
      $(this).parent().parent().parent().parent().parent().siblings().removeClass('active');
      let prod = $(this).siblings('h3').text();
      window.location = '/sign-up/?sel='+prod;
      $('.all-products-list select option:contains('+prod+')').attr('selected', 'selected');
    });


    $(document).on('gform_post_render', function( event, formId, currentPage ) {
      if (currentPage === 1) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const prod = urlParams.get('sel')
        $('.all-products-list select option:contains('+prod+')').attr('selected', 'selected');
      }

      // let fname = $('#input_4_19');
      // let lname = $('#input_4_20');
      // let uname = $('#input_4_63');
      // let final = [];

      // fname.on('focusout', function() {
      //   final.push($(this).val());
      // });

      // lname.on('focusout', function() {
      //   final.push($(this).val());
      //   let st = final.toString();
      //   let lc = st.toLowerCase();
      //   uname.val(lc.replace(/,/g, '.'));
      // });

      // $('#gform_previous_button_4_17').on('click', function() {
      //   setTimeout(() => {
      //     $('.prod-intro').show();
      //     let ht = $('.col-wrapper').height();
      //     $('#gform_next_button_4_48').css('marginTop', ht + 50);
      //   }, 1500);
      // });
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSignup.js